import { lazy, Suspense } from 'react';

const ReactQueryDevtools = lazy(() =>
  import('@tanstack/react-query-devtools').then((m) => ({
    default: m.ReactQueryDevtools,
  })),
);

const TanStackRouterDevtools = lazy(() =>
  import('@tanstack/react-router-devtools').then((m) => ({
    default: m.TanStackRouterDevtools,
  })),
);

export function DevTools() {
  if (import.meta.env.DEV) {
    return (
      <Suspense>
        <ReactQueryDevtools buttonPosition="bottom-left" theme="dark" />
        <TanStackRouterDevtools position="bottom-right" />
      </Suspense>
    );
  }

  return null;
}
